import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CONFIGURATION } from "../../app.constants";

@Component({
    selector: "logout-component",
    template: require("./logout.component.html")
})

export class LogoutComponent {

    constructor(private cecRouter: Router) {
            window.location.href =  CONFIGURATION.baseUrls.cloudUi + "logout";
        
    }

}


// WEBPACK FOOTER //
// ./src/app/components/logout/logout.component.ts